import Layout from "components/Layout";
import React from "react";
import ItemSettingEditForm from "./components/ItemSettingEditForm ";

function ItemSettingEditPage() {
  return (
    <Layout title="SMS 항목 수정/삭제">
      <ItemSettingEditForm />
    </Layout>
  );
}

export default ItemSettingEditPage;
